export const userActionTypes = {
  getMe: '[Users] - get personal info',
  openAvatarUploadModal: '[Users] - open avatar upload modal',
  uploadAvatar: '[Users] - upload avatar',
  refreshMe: '[Users] - trigger refresh personal details',
};
